<template>
  <neon-main>
    <div class="index-main">
      <account-detail></account-detail>
    </div>
  </neon-main>
</template>

<script>
  import Main from '../common/Main.vue'
  import AccountDetail from './components/AccountDetail'

  export default {
    name: 'about',
    components: {
      'account-detail': AccountDetail,
      'neon-main': Main
    }
  }
</script>

<style scoped>
  .index-main{
    margin: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/modules/demo/demo.vue